<template>
<div class="immo-listing__border">
  <saved-search-wizard :saved-search="savedSearch" no-contact-form @change="onChange">
  <div class="text-center">
    <button class="mr-2 btn btn-primary"
                  @click="ok()">{{ $t("Speichern") }}</button>
    <button class="savedsearch__cancel"
            @click="cancel()"
            :title="$t('Abbrechen')">
        <span class="far fa-times"></span>
    </button>
  </div>
  </saved-search-wizard>
</div>
</template>

<script>
import SavedSearchWizard from "./contact/SavedSearchWizard";

export default {
  name: "SavedSearchEdit",

  components: {
    SavedSearchWizard
  },

  props: [
    "savedSearch"
  ],

  data() {
    return {
      inquiry: null
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    ok() {
      this.$emit("save", this.inquiry);
    },

    onChange(inquiry) {
      inquiry.id = this.savedSearch.id;
      this.inquiry = inquiry;
    }
  }
};
</script>
